import { BodyLong, Heading, HorizontalSpace, Link, Table, VerticalSpace } from '@elhub/ds-components'
import { Warning } from '@elhub/ds-icons'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link as NavLink } from 'react-router-dom'

import { MaskinportenMessages } from '../../locales/messages/maskinporten'

const jobs = [
  {
    Type: 'portfolio-move',
    Description:
      'This job exports meter readings from the previous balance supplier to the new balance supplier. It is used when there is a transfer of responsibilities between suppliers, and it works as an alternative to the bulk process managed by Elhub (specifically referred to as BRS-NO-315)'
  },
  {
    Type: 'portfolio-full',
    Description:
      'This job is similar to portfolio-move, but it provides the entire portfolio for a balance supplier.'
  },
  {
    Type: 'portfolio-grid-owner',
    Description:
      ' This job delivers all metering readings for a specific grid owner and includes a historical record spanning three years. '
  },
  {
    Type: 'end-user-market-report',
    Description: 'This job generates and provides various market reports.'
  },
  {
    Type: 'ssb-report',
    Description: 'This job generates and provides SSB statistics report.'
  }
]

const DataExport = () => {
  const { t } = useTranslation()
  return (
    <>
      <Heading>Overview</Heading>
      <VerticalSpace />
      <BodyLong size='small'>
        The Data Export API endpoints provide various energy data file exports to serve multiple requirements.
      </BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>
        These exports are generated by on demand or scheduled jobs. There are multiple <b>Job Types</b> that
        provide different sets of data in the file exports. Market parties gain access to fetch files for
        different <b>Job Types</b> depending on their needs and their access level to the data.
      </BodyLong>
      <VerticalSpace />
      <Table size='small'>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader scope='col'>Job Type</Table.ColumnHeader>
            <Table.ColumnHeader scope='col'>Description</Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {jobs.map(({ Type, Description }) => (
            <Table.Row key={Type}>
              <Table.HeaderCell scope='row' style={{ width: '200px', overflowWrap: 'anywhere' }}>
                {Type}
              </Table.HeaderCell>
              <Table.DataCell>{Description}</Table.DataCell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      <VerticalSpace />
      <BodyLong spacing style={{ color: 'red', fontStyle: 'italic' }}>
        {t(MaskinportenMessages.SCOPES_PARAGRAPH_2_PART_1 as any)}
      </BodyLong>
      <VerticalSpace />
      <div style={{ backgroundColor: '#FFEEF4', padding: '20px' }}>
        <BodyLong style={{ display: 'inline-flex' }}>
          <Warning style={{ height: '20px', width: '20px', color: 'red', margin: '0px 15px 0px 0' }} />
          <Heading>Access Control</Heading>
        </BodyLong>
        <BodyLong size='small' style={{ marginLeft: '35px' }}>
          This is a Protected API. Elhub manages access through{' '}
          <Link as={NavLink} to='https://api.elhub.no/maskinporten/getting-started'>
            Maskinporten
          </Link>
          <HorizontalSpace size='0.2' />
          scopes.
        </BodyLong>
      </div>
    </>
  )
}
export default DataExport
